import React from "react";
import {useSelector} from "react-redux";
import {getInitials, capitalize} from "../../../_helpers/StringHelpers";
import {downloadAgentUrl} from "../../../_helpers/ExternalServicesHelper";

const CompanyInfo = () => {
    const currentCompany = useSelector(state => state.session.current_company);

    return (
        <div className="d-flex flex-column p-6 bg-diagonal">
            <div style={{'zIndex': 4}} className="d-flex flex-center justify-content-between">
                <div className="symbol symbol-70 symbol-light-danger mr-5 ">
                    <div className="symbol-label">
                        <span className="symbol-label font-size-h2 font-weight-bold">{getInitials(currentCompany.company.company_name)}</span>
                    </div>
                </div>

                <div className="rounded-top m-0" style={{flex: 1}}>
                    <h4 className="text-dark font-weight-bolder">{currentCompany.label}</h4>
                    <div className="text-dark font-size-sm mb-3">
                        <span className="label label-dot label-success"></span>
                        {''} current company
                    </div>

                    <a href={downloadAgentUrl(currentCompany.id)}
                       target="_blank" rel="noopener noreferrer"
                       className="btn btn-success font-weight-bolder font-size-sm d-inline-flex px-8">
                        <i className="flaticon2-download pr-4 pt-1" style={{"fontSize": "24px"}}></i>

                        <div className="d-flex flex-column text-right pr-3">
                            <div>Download Agent</div>
                            <small>v{currentCompany.company.odVersion.version}</small>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default CompanyInfo;
